import { useDataChange } from 'Simple/Data.js'

export function useOnChange(props) {
  let change = useDataChange({
    context: 'event_action',
    viewPath: props.viewPath,
  })
  return function onChange(value) {
    change(next => {
      next.data.is_skippable = value
      next.data.create_task = false
    })
  }
}
